export default __webpack_public_path__ + "static/media/DNo.14-1.b2e491e9.jpg";